import React, { } from 'react';
import { Button, Col } from 'reactstrap'
import { Dialog } from 'primereact/dialog';
import { AlertTriangle } from "react-feather";

export const AlertDataTable = (props) => {

    const {
        titleAlert,
        visibleAlert,
        headerColor = "#0d3b59",
        onHideAlert,
        sizeAlert = "medium-dialog",
        maskClassName = "",
        loadingAlert = false,
        titleLoading,
        titleNotLoading,
        titleDanger,
        buttonAcept = false,
        actionAcept,
        messageAlert,
        alert1 = true,
        titleAlert1,
        buttonCancell = true,
        actionCancell = false,
        nameCancell,
        newDesingDialog = false,
        iconNewDialog = "",
        closable = true,
        newDesingDialogDelete = false
    } = props;

    return (
        <>
            <Dialog
                header={
                    newDesingDialog ?
                        <div className="Global-dialog-header">
                            <div className="Global-dialog-header__content">
                                <div className="Global-dialog-icon">
                                    <i className={iconNewDialog}></i>
                                </div>
                                <div>
                                    <div className="Global-dialog-title">
                                        {titleAlert}
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        titleAlert ?? "---"
                }
                visible={visibleAlert}
                headerStyle={{
                    backgroundColor: headerColor,
                    color: 'white',
                    fontWeight: 'bold',
                }}
                pt={{
                    header: { style: { backgroundColor: headerColor, color: 'white' } },
                    headerIcon: { style: { color: 'white' } },
                }}
                onHide={onHideAlert}
                className={
                    newDesingDialog ?
                        (newDesingDialogDelete
                            ? `seller-dialog seller-dialog seller-danger seller-small-v `
                            : `Global-dialog Global-dialog Global-blue Global-small-v22 `)
                        :
                        sizeAlert
                }
                maskClassName={maskClassName}
                draggable={false}
                footer={
                    <>
                        {
                            buttonAcept && <Button
                                size="sm"
                                color="secondary"
                                type="button"
                                onClick={actionAcept}
                                disabled={loadingAlert}
                            >
                                {loadingAlert ? (
                                    <>
                                        <i className="fa fa-spinner fa-spin mr-1"></i>
                                        {titleLoading ?? "Procesando..."}
                                    </>
                                ) : (
                                    titleNotLoading ?? "---"
                                )}
                            </Button>
                        }
                        {
                            buttonCancell && <Button
                                size="sm"
                                type="button"
                                color="danger"
                                className="btn-air-light"
                                onClick={actionCancell ? nameCancell : onHideAlert}
                            >
                                {titleDanger ?? "---"}
                            </Button>
                        }

                    </>
                }
                closable={closable}
            >
                <Col sm="12" className='pl-0 pr-0 pt-2' >
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                        marginBottom: "15px"
                    }}>
                        <div style={{
                            backgroundColor: "#ffe6e6",
                            borderRadius: "50%",
                            width: "59px",
                            height: "50px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                            className='p-colorIcon'


                        >
                            <AlertTriangle
                                size={28}
                                color="#c92a2a"
                                style={{ display: "block" }}
                            />
                        </div>
                        <div>
                            <p
                                className="mb-0 p-label-alert"
                                style={{
                                    fontSize: "13px",
                                    color: "#0d3b59"
                                }}
                            >
                                {messageAlert ?? "---"}
                            </p>
                        </div>
                    </div>
                    {
                        alert1 ?
                            <div style={{
                                background: "#f8fbff",
                                padding: "12px 14px",
                                borderRadius: "8px",
                                border: "1px solid #d7e7f5"
                            }}
                                className='p-label-alertMessage'


                            >
                                <span className='p-label-alert' style={{ fontWeight: 500, color: "#0d3b59" }}>
                                    {titleAlert1 ?? "---"}
                                </span>
                            </div>
                            :
                            <div
                                style={{
                                    color: "#856404",
                                    fontSize: "0.78rem",
                                    marginTop: "6px",
                                    fontWeight: "500",
                                    backgroundColor: "#fff3cd",
                                    padding: "4px 10px",
                                    borderRadius: "6px",
                                    boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    border: "1px solid #ffeeba",
                                }}
                                className='p-label-alertMessage'
                            >
                                <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
                                {titleAlert1 ?? "---"}
                            </div>
                    }
                </Col>
            </Dialog >
        </>
    )
}